import axiosInstance from './axios';
import { LeaveBalance } from '../../types';

export interface LeaveBalanceSummary {
  currentYear: number;
  accruedDays: number;
  usedDays: number;
  remainingDays: number;
  previousYears: Array<{
    year: number;
    accruedDays: number;
    usedDays: number;
  }>;
}

class LeaveBalancesService {
  private basePath = '/leave-balances';

  /**
   * Get my current leave balance
   */
  async getMyBalance(): Promise<LeaveBalance> {
    const response = await axiosInstance.get<LeaveBalance>(
      `${this.basePath}/me`
    );
    return response.data;
  }

  /**
   * Get my balance summary (current + previous years)
   */
  async getMySummary(): Promise<LeaveBalanceSummary> {
    const response = await axiosInstance.get<LeaveBalanceSummary>(
      `${this.basePath}/me/summary`
    );
    return response.data;
  }

  /**
   * Get my balance history across all years
   */
  async getMyHistory(): Promise<LeaveBalance[]> {
    const response = await axiosInstance.get<LeaveBalance[]>(
      `${this.basePath}/me/history`
    );
    return response.data;
  }

  /**
   * Get balance for a specific employee (Manager/HR)
   */
  async getEmployeeBalance(
    employeeId: number,
    year?: number
  ): Promise<LeaveBalance> {
    const response = await axiosInstance.get<LeaveBalance>(
      `${this.basePath}/employee/${employeeId}`,
      { params: { year } }
    );
    return response.data;
  }

  /**
   * Get balance summary for a specific employee (Manager/HR)
   */
  async getEmployeeSummary(
    employeeId: number
  ): Promise<LeaveBalanceSummary> {
    const response = await axiosInstance.get<LeaveBalanceSummary>(
      `${this.basePath}/employee/${employeeId}/summary`
    );
    return response.data;
  }
}

export const leaveBalancesService = new LeaveBalancesService();
